import React from 'react';
import { Form, Checkbox, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

/**
 * Reusable Migration Options Checkboxes component
 * @param {boolean} showUseStoredInfoCheckbox - Whether to show the "Use stored source information" checkbox
 * @param {boolean} inspectionMode - Whether this is source inspection mode
 */
export const MigrationOptionsCheckboxes = ({ showUseStoredInfoCheckbox = true, inspectionMode = false }) => {
    return (
        <>
            {/* Use Stored Info Option - only show if not migrate_by_vm */}
            {showUseStoredInfoCheckbox && (
                <Form.Item name="useStoredInfo" valuePropName="checked">
                    <Checkbox>
                        Use stored source information, if available.{' '}
                        <Tooltip title="If a migration readiness check was previously performed on your source(s), you have the option to use stored details. Do not select if you have made changes or updates to your sources since the last check.">
                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                    </Checkbox>
                </Form.Item>
            )}

            {/* Ignore Validation Errors Option - only show in migration mode */}
            {!inspectionMode && (
                <Form.Item name="ignoreValidationErrors" valuePropName="checked">
                    <Checkbox>
                        Ignore Validation Errors{' '}
                        <Tooltip title="All validation errors should be ignored - please proceed at your own risk.">
                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                    </Checkbox>
                </Form.Item>
            )}
        </>
    );
};
